<template>
  <div
    class="login-center"
    :class="[{ 'no-padding': hadLoadPayType }, { 'on-pay': hadLoadPayType }]"
    v-if="isLogin"
  >
    <div class="account-info">
      <div class="account-info-bg" :style="accountInfoStyle"></div>
      <div class="role-info">
        <img
          v-if="showIcon && userAvatar"
          class="role-info-ico"
          :src="userAvatar"
          alt="role-icon"
        />
        <div class="role-info-text">
          <div class="account">
            <span class="account-text">{{ userName }}</span>
            <a
              v-if="isHome && showSwicthBtn"
              class="account-change j-role-switch"
              href="javascript:;"
              @click="handleShowSelectRolePopup"
            >
            </a>
            <a
              v-else-if="!isInWebview && showSwicthBtn"
              class="account-change"
              href="javascript:;"
              @click="handleGoLogOut"
            >
              [{{ letter.logout }}]
            </a>
          </div>
          <div class="role" v-if="roleName">{{ roleName }}</div>
        </div>
      </div>
      <div
        v-if="isShowCouponBtn"
        id="loginInfoCouponBtn"
        class="account-btn"
        @click="handleCouponButtonClick"
      >
        <div class="account-btn-ico" :style="couponIconStyle">
          <em class="red-dot" v-if="showRedDot"></em>
        </div>
        <div class="account-btn-text">
          {{ letter.v3MyCoupons }} ({{ gameCouponEnableList.length }})
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import globalConfig from '@utiles/officialStore/globalConfig';
import login from '@mixins/officialTopupNew/login';
import account from '@mixins/officialTopupNew/account';
import coupon from '@mixins/officialTopupNew/coupon';
import { GET_BALANCE_USER_DATA_OF_OPEN } from '@store/officialTopupNew/coins';
import { mapGetters, mapState } from 'vuex';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV35';
export default {
  name: 'LoginInfo',
  props: {
    showSwicthBtn: {
      default: false
    },
    showIcon: {
      default: false
    },
    showCouponBtn: {
      default: false
    },
    showAccountBg: {
      default: false
    },
    hadLoadPayType: {
      default: false
    }
  },
  mixins: [login, account, coupon],
  computed: {
    ...mapState({
      isLandscape: state => state.page.isLandscape,
      loginAccount: state => state.login.loginAccount,
      displayName: state => state.login.displayName,
      showCoinEntry: state => state.coins.showCoinEntry,
      isInWebview: state => state.isInWebview,
      gameId: state => state.gameId
    }),
    ...mapGetters(['getCoinsName']),
    couponIconStyle() {
      return `background-image: url(${this.picList.couponIcon});`;
    },
    accountInfoStyle() {
      if (!this.showAccountBg) {
        return '';
      }
      const defaultStyle = `background-color: var(--moduleBackgroundColor); color: #333333;`;
      if (this.isLandscape) {
        if (this.picList?.accountBg) {
          return `background-image: url(${this.picList.accountBg});`;
        } else {
          return defaultStyle;
        }
      } else {
        if (this.picList?.mAccountBg) {
          return `background-image: url(${this.picList.mAccountBg});`;
        } else {
          return defaultStyle;
        }
      }
    },
    userName() {
      // 20240725 需求人: 邓智轩 特殊处理：顽星域名账号展示隐藏前缀 以DISPLAY_NAME字段作为账号显示名称
      if (globalConfig.getMainHost() === 'playplanetgame.com') {
        return this.displayName;
      } else {
        return this.loginAccount;
      }
    },
    isHome() {
      return this.$route.name == 'home';
    },
    userAvatar() {
      return this.picList?.avatar;
    },
    isShowCouponBtn() {
      return this.showCouponBtn && ![386, 456].includes(+this.gameId);
    }
  },
  // 平台币已下架，接口不调用
  // watch: {
  //   isLogin(newVal) {
  //     if (newVal) {
  //       this.$store.dispatch(GET_BALANCE_USER_DATA_OF_OPEN);
  //     }
  //   }
  // },
  methods: {
    handleShowSelectRolePopup() {
      this.showSelectRolePopup();
      clickButton({
        btnName: 'select_role',
        locationKey: locationType.accountInfo
      });
    },
    handleGoLogOut() {
      clickButton({
        btnName: 'logout',
        locationKey: locationType.accountInfo
      });
      this.goLogOut();
    }
  },
  created() {
    // 权益中心打开时带有showCoupon=1参数直接展示优惠券
    globalConfig.getHrefParam('showCoupon') === '1' &&
      this.handleCouponButtonClick();
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
@import '@assets/scss/officialTopupNew/animate.scss';
.login-center {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: 0 40px;

  .account-info {
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 140px;
    margin: 30px auto;
    padding: 0 20px;
    font-size: 22px;
    color: #ffffff;
    border-radius: 10px;

    &-bg {
      z-index: 0;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .role-info {
      z-index: 1;
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      &-ico {
        width: 80px;
        height: 80px;
        margin-right: 18px;
      }
      &-text {
        font-size: 22px;
        .account {
          position: relative;
          margin-bottom: 14px;
          &-text {
            vertical-align: middle;
          }
          &-change {
            display: inline-block;
            margin: auto;
            width: 50px;
            height: 31px;
            margin-left: 16px;
            background: url($commonImg + 'change-role.png') no-repeat
              center/contain;
            vertical-align: middle;
          }
        }
      }
    }
  }
  .account-btn {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 104px;
    border-radius: 20px;
    gap: 13px;
    cursor: pointer;

    &-ico {
      margin: 0 20px;
      width: 58px;
      height: 63px;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      animation: shake 3s ease infinite;
    }

    &-text {
      flex: 1;
      line-height: 1.2;
      text-align: center;
      color: #333333;
      font-size: 24px;
      color: #fff;
    }

    .red-dot {
      position: absolute;
      top: 0;
      right: 4px;
      width: 16px;
      height: 16px;
      background-color: #ff2800;
      border-radius: 50%;
      transform: translate(20px, -5px);
    }
  }

  &.no-padding {
    padding: 0;
  }
  &.on-pay {
    .account-info {
      height: 120px;
      margin: 0;
      padding: 0;
      color: #333333;
    }
  }
}

[dir='rtl'] {
  .account-info-bg {
    transform: scaleX(-1);
  }
}

#ssr-page.landscape {
  .login-center {
    position: relative;
    max-width: 1507px;
    height: 82px;
    margin-top: 22px;
    padding: 0;

    .account-info {
      width: 100%;
      height: 100%;
      margin: auto;
      padding: 0 30px;
      align-items: center;

      .role-info {
        &-text {
          font-size: 16px;
          .account {
            margin-bottom: 12px;
          }
        }
        &-ico {
          width: 60px;
          height: 60px;
          color: #333333;
        }

        &-text {
          font-size: 16px;
          .account {
            margin-bottom: 10px;

            &-change {
              right: -40px;
              width: 32px;
              height: 20px;
            }
          }
        }
      }
    }

    .account-btn {
      flex-direction: row;
      height: 80px;

      &-text {
        margin-top: 8px;
        font-size: 18px;
      }
      .red-dot {
        top: 2px;
        right: 5px;
        left: unset;
      }
    }

    &.on-pay {
      height: auto;
      .account-info {
        height: 60px;
        align-items: flex-end;
      }
    }
  }
}
</style>
